import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDownArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 7,
	height: 7,
	viewBox: "0 0 7 7",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.73958 0V4.34375L0.875 2.47917L0 3.35417L3.35417 6.70833L6.70833 3.35417L5.83333 2.47917L3.96875 4.34375V0H2.73958Z",
		fill: "white"
	})
});
export default SvgDownArrow;
